<template>
  <div class="CanvasShareDialog">
    <el-dialog
      class="customDialog"
      :title="dialogTitle"
      :visible.sync="isShow"
      @close="closeDialog"
      top="15vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="formContainer">
        <div>
          <img src="@/assets/images/share-image.png" alt="img" />
        </div>
        <div class="text">
          <span>画布分享</span>
          <span>分享画布不得发布涉及国家秘密信息和一切违法内容。</span>
        </div>
        <div class="switch">
          <span class="open" v-if="enableShare">开</span>
          <span class="close" v-if="!enableShare">关</span>
          <el-switch
            v-model="enableShare"
            @change="changeSwitch"
            active-color="#00A4F0"
            inactive-color="rgba(255, 255, 255, 0.2)"
            :disabled="permissionLevel <= PermissionLevel.LOOKER"
          >
          </el-switch>
        </div>
      </div>
      <div
        class="codeBox"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        v-if="enableShare"
      >
        <div class="code-img">
          <img
            :src="
              baseurl +
              'platform/publics/create/qrCode?content=' +
              encodeLink +
              '&type=STREAM'
            "
            alt="img"
          />
        </div>
        <div class="text">复制链接地址给好友</div>
        <el-input
          :value="link"
          placeholder="请输入内容"
          :readonly="true"
        ></el-input>
        <div class="btn" @click="copy">复制</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { enableCanvasShare } from '@/api/canvasManagement'
import { PermissionLevel } from '@/configs/constants'
import { mapGetters } from 'vuex'
export default {
  name: 'CanvasShareDialog',
  props: {},
  components: {},
  data () {
    return {
      shareId: '',
      isShow: false,
      loading: false,
      dialogTitle: '画布分享',
      dialogType: '',
      enableShare: false,
      canvasId: 0,
      qrCodeUrl: '',
      baseurl: process.env.VUE_APP_API_BASE_URL,
      version: '',
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['permissionLevel']),
    link () {
      return this.composition(this.shareId)
    },
    encodeLink () {
      return window.encodeURIComponent(this.link)
    }
  },
  methods: {
    open (canvasId, enableShare, shareId = '') {
      this.canvasId = canvasId
      this.enableShare = enableShare
      this.shareId = shareId
      this.isShow = true
    },
    closeDialog () {
      this.$emit('refresh')
    },
    /**
     * 合成分享路径
     * @param {String} short 短链，必填项，baseurl目录
     */
    composition (short, baseurl = '/canvasShare') {
      return `${window.location.origin}${baseurl}/${short}`
    },
    async changeSwitch (v) {
      this.loading = true
      const { data: shareId } = await enableCanvasShare({ canvaId: this.canvasId })
      this.shareId = shareId
      // if (v) {
      //   // 如果是启用地图分享，则配置分享默认值
      //   await shareMapSetting(shareId, this.canvasId)
      // }

      this.loading = false
      this.$emit('refresh')
    },
    copy () {
      const aux = document.createElement('input')
      aux.setAttribute('value', this.link)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$Message('success', '复制成功')
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.CanvasShareDialog {
  .formContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 10px;
    box-sizing: border-box;
    margin-bottom: 10px;
    .text {
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: start;
      transform: translateX(-25px);
      > span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 300;
        color: #bbbbbb;
      }
      > span:first-child {
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 4px;
      }
    }
    .switch {
      position: relative;
      .open {
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #ffffff;
        display: inline-block;
        left: 7px;
        top: 1px;
        z-index: 1000;
        position: absolute;
        pointer-events: none;
      }
      .close {
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #ffffff;
        display: inline-block;
        right: 7px;
        top: 1px;
        position: absolute;
        pointer-events: none;
      }
    }
  }
  .codeBox {
    width: 560px;
    height: 170px;
    background: #303133;
    border-radius: 6px;
    padding: 30px;
    box-sizing: border-box;
    padding-right: 20px;
    position: relative;
    .code-img {
      width: 110px;
      height: 110px;
      border-radius: 10px;
      position: absolute;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 95px;
        height: 95px;
      }
    }
    .text {
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 300;
      color: #999999;
      position: absolute;
      top: 50px;
      left: 160px;
    }
    .btn {
      width: 60px;
      height: 32px;
      border: 1px solid #00a4f0;
      border-radius: 6px;
      font-size: 12px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #00a4f0;
      line-height: 30px;
      position: absolute;
      right: 20px;
      top: 80px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.CanvasShareDialog {
  .customDialog {
    .el-dialog {
      width: 600px;
      .el-input__inner {
        width: 308px;
        position: absolute;
        top: 35px;
        left: 130px;
      }
      .el-switch__core{
        border-color: rgba(255, 255, 255, 0) !important;
      }
    }
  }
}
</style>
